export const incomeTypes = Object.freeze({
  JOB: 'JOB',
  SELF_EMPLOYMENT: 'SELF_EMPLOYMENT',
  UNEMPLOYMENT: 'UNEMPLOYMENT',
  SOCIAL_SECURITY_BENEFIT: 'SOCIAL_SECURITY_BENEFIT',
  RETIREMENT: 'RETIREMENT',
  PENSION: 'PENSION',
  INVESTMENT_INCOME: 'INVESTMENT_INCOME',
  CAPITAL_GAINS: 'CAPITAL_GAINS',
  RENTAL_OR_ROYALTY_INCOME: 'RENTAL_OR_ROYALTY_INCOME',
  ALIMONY_RECEIVED: 'ALIMONY_RECEIVED',
  SCHOLARSHIP: 'SCHOLARSHIP',
  CANCELED_DEBT: 'CANCELED_DEBT',
  COURT_AWARDS: 'COURT_AWARDS',
  PRIZES_AWARDS_GAMBLING_WINNINGS: 'PRIZES_AWARDS_GAMBLING_WINNINGS',
  JURY_DUTY_PAY: 'JURY_DUTY_PAY',
  OTHER_INCOME: 'OTHER_INCOME',
  FARMING_OR_FISHING_INCOME: 'FARMING_OR_FISHING_INCOME',
});

export const incomeLabel = {
  DEFAULT: 'selectIncomeType',
  JOB: 'job',
  SELF_EMPLOYMENT: 'selfEmployed',
  UNEMPLOYMENT: 'unemployment',
  SOCIAL_SECURITY_BENEFIT: 'socialSecurity',
  RETIREMENT: 'retirementIncomeSourceType',
  PENSION: 'pension',
  INVESTMENT_INCOME: 'investmentSourceType',
  CAPITAL_GAINS: 'capitalGains',
  RENTAL_OR_ROYALTY_INCOME: 'rentalOrRoyalty',
  ALIMONY_RECEIVED: 'alimonyReceived',
  SCHOLARSHIP: 'scholarship',
  CANCELED_DEBT: 'canceledDebt',
  COURT_AWARDS: 'courtAwards',
  PRIZES_AWARDS_GAMBLING_WINNINGS: 'gambling',
  JURY_DUTY_PAY: 'juryDutyPay',
  OTHER_INCOME: 'other',
  FARMING_OR_FISHING_INCOME: 'farmingOrFishing',
};

export type IncomeType = (typeof incomeTypes)[keyof typeof incomeTypes];
